// DOM read/write helpers for overlay forms.
//
// `readOverlayForm` collects every [data-field] input's current value into a
// plain map (checkboxes -> boolean, everything else -> string). Non-input
// [data-field] elements (spans/divs used as display slots, e.g. the logo
// form's src-display) contribute `undefined` and are ignored by the
// serializer. `writeOverlayForm` applies a { field: value } map back onto the
// matching inputs for pre-filling the edit form. Pure DOM, no Stimulus.

export function readOverlayForm(formEl) {
  const result = {}
  formEl.querySelectorAll("[data-field]").forEach((el) => {
    const key = el.dataset.field
    if (el.type === "checkbox") {
      result[key] = el.checked
    } else {
      result[key] = el.value
    }
  })
  return result
}

export function writeOverlayForm(formEl, values) {
  Object.entries(values).forEach(([key, value]) => {
    const el = formEl.querySelector(`[data-field="${key}"]`)
    if (!el) return
    if (el.type === "checkbox") {
      el.checked = !!value
    } else {
      el.value = value
    }
  })
}
